import * as axios from 'axios';
import _ from 'lodash';

export async function searchClients(emailOrPhoneNumber) {
  try {
    const res = await axios.get(
      `/my_client/clients/filter.json?mcsearch=${emailOrPhoneNumber}&for_appointment=true`
    );
    return _.get(res, 'data.clients', []);
  } catch (error) {
    console.log(error);
    // eslint-disable-next-line
    Raven.captureException(error);
    return [];
  }
}
